import React from "react";
import { View } from "react-native";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import StreamPlayersView from "./StreamPlayersView";

const StreamPlaceholder = () => {
  const deviceSize = useDeviceSize();
  const isMobile =
    deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS;

  return (
    <View
      style={{
        borderRadius: 8,
        overflow: "hidden",
        aspectRatio: isMobile ? undefined : 16 / 9,
        height: isMobile ? "auto" : undefined,
      }}
    >
      <StreamPlayersView />
    </View>
  );
};

export default StreamPlaceholder;
